const FormActionEnum = Object.freeze({
  LIST: 0,
  VIEW: 1,
  ADD: 2,
  EDIT: 3,
  DELETE: 4,
  SPECIAL: 5,
  DUPLICATE: 6
});

const AdminUserEnum = Object.freeze({
  INITIAL: 0,
  CHANGE: 1,
  RESET: 2,
  UNLOCK: 3
});

const AccesLimitEnum = Object.freeze({
  INITIAL: 0,
  CHANGE: 1,
  RESET: 2,
  UNLOCK: 3
});

const PersonTypeEnum = Object.freeze({
  CLIENTS: { id: 1, name: "Cliente" },
  AGENTS: { id: 2, name: "Agente" },
  BROKERS: { id: 3, name: "Comercial" },
  THIRDPARTIES: { id: 4, name: "Tercero" }
});


const ProtectionTypeEnum = Object.freeze({
  NO_PROTECTION: 1,
  RANDOM_KEY: 2,
  FIXED_KEY: 3
});

export { FormActionEnum, AdminUserEnum, AccesLimitEnum, PersonTypeEnum, ProtectionTypeEnum };
